import Typography from '@material-ui/core/Typography';
const Analytics=()=>{
    return(
        <Typography variant="h3">Analytics & Reports</Typography>
    );
}
export default Analytics;